import { ReadOutlined, SmileOutlined } from '@ant-design/icons'
import { Avatar, List, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { UserHoverCard } from '@/components'
import { Group, useGetGroupAdminsQuery, useGetGroupFollowersQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import { GroupSidebarUsers } from './group-sidebar-users.component'
import s from './group-sidebar.module.less'

interface GroupSidebarProps {
  group: Group
  isGroupAdmin: boolean
}

export const GroupSidebar: React.FC<GroupSidebarProps> = ({ group, isGroupAdmin }) => {
  const [t] = useTranslation()

  const description = group.description && (
    <div className={s.description}>
      <Typography.Title level={5}>
        <span>
          <ReadOutlined style={{ marginRight: 8 }} />
          {t('group.info')}
        </span>
      </Typography.Title>
      <div style={{ marginLeft: 26, marginBottom: 8 }}>{group.description}</div>
    </div>
  )

  const isGeneralGroup = group.groupId === 1
  return (
    <div className={s.sidebar}>
      {description}
      {!isGeneralGroup && (
        <List
          header={
            <Typography.Title level={5}>
              <span>
                <SmileOutlined />
                {t('group.creator')}
              </span>
            </Typography.Title>
          }
          itemLayout='horizontal'
          size='small'
          split={false}
          dataSource={[group.creator]}
          renderItem={(u) => (
            <List.Item key={u.userId}>
              <List.Item.Meta
                avatar={<Avatar src={u.avatarUrl} style={{ marginLeft: 20 }} />}
                title={
                  <UserHoverCard email={u.email}>
                    <Link to={routes.users.page(u.email)}>{u.name}</Link>
                  </UserHoverCard>
                }
              />
            </List.Item>
          )}
        />
      )}

      {!isGeneralGroup && (
        <GroupSidebarUsers
          title={t('group.admin')}
          group={group}
          isGroupAdmin={isGroupAdmin}
          query={useGetGroupAdminsQuery}
        />
      )}
      <GroupSidebarUsers
        title={t('group.follower')}
        group={group}
        isGroupAdmin={isGroupAdmin}
        query={useGetGroupFollowersQuery}
      />
    </div>
  )
}
